import ZohoCrm from "../Components/img/ZohoProducts/zoho-crm.png";
import ZohoBooks from "../Components/img/ZohoProducts/zoho-books.png";
import ZohoDesk from "../Components/img/ZohoProducts/zoho-desk.png";
import ZohoOne from "../Components/img/ZohoProducts/zoho-one.png";
import zohoMail from "../Components/img/ZohoProducts/zoho-mail.png";
import zohoAnalytics from "../Components/img/ZohoProducts/zoho-analytics.png";

const products = [
  {
    title: "Zoho CRM",
    description:
      "Customer relationship management software to manage sales, leads, contacts, and customer interactions.",
    imgSrc: ZohoCrm,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=c538d776082f6aa5b2e1f4e384b808cf",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=20ca71f336a2b50a2cda1a3697da49e8",
  },
  {
    title: "Zoho Desk",
    description:
      "Customer support and help desk software for managing tickets and delivering exceptional service.",
    imgSrc: ZohoDesk,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=b65fe346000e453c1172f05c529b256d",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=69950de2f8848736abd43f78775cf216",
  },
  {
    title: "Zoho Books",
    description:
      "Cloud-based accounting software for invoicing, expense tracking, GST compliance, and financial management.",
    imgSrc: ZohoBooks,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=69c24028bd5cc37daa1c52a73bb21aca",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=cb202c3c8d1b6aad93bb0df9067f7828",
  },
  {
    title: "Zoho Analytics",
    description:
      "Business intelligence and analytics platform for creating reports, dashboards, and data visualizations.",
    imgSrc: zohoAnalytics,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=98a4aa91bca022b98a3ab8f606c1afee",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=1e7ed5db14949fa4bb13408c9bab2b18",
  },
  {
    title: "Zoho Mail",
    description:
      "Secure and feature-rich email client with advanced collaboration tools.",
    imgSrc: zohoMail,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=eb1ad28932a03dca40c077c15e8ff1a7",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=9dcc587ce287c7895cdb1090143f6d9d",
  },
  {
    title: "Zoho One",
    description:
      "An all-in-one business suite that provides access to 45+ integrated Zoho applications with a single subscription.",
    imgSrc: ZohoOne,
    indiaLink:
      "https://store.zoho.in/ResellerCustomerSignUp.do?id=eb1ad28932a03dca40c077c15e8ff1a7",
    usaLink:
      "https://store.zoho.com/ResellerCustomerSignUp.do?id=9dcc587ce287c7895cdb1090143f6d9d",
  },
];

export default products;
